module.exports = __webpack_public_path__ + "img/type2.a0379262.png";